<template>
  <b-modal
    :id="'memberinfo-' + item.id.toString()"
    centered
    hide-footer
    hide-header
    size="xl"
  >
    <div v-if="processing">
      <ProcessingGif :classes="'popup-processing-image'" :processing="processing" />
    </div>
    <div v-else-if="memberId">
      <div class="centered-block">
        <div class="step-title">Member Information</div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 px-0 px-md-2">
          <div class="form-group mb-0">
            <label>Member ID: </label>
            <span class="font-weight-normal px-2"> {{ memberId }} </span>
          </div>
          <div class="form-group mb-0">
            <label>Username: </label>
            <span class="font-weight-normal px-2"> {{ username }} </span>
          </div>
          <div class="form-group mb-0">
            <label>Password: </label>
            <span class="font-weight-normal px-2"> {{ password }} </span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="centered-block">
        <div class="step-title">No membership found</div>
      </div>
    </div>
    <b-link block class="centered-block close-button" variant="secondary" @click="close()">&times;</b-link>
  </b-modal>
</template>

<script>
import axios from 'axios'
import ProcessingGif from '@/components/ProcessingGif'

export default {
  name: 'MemberInfo',
  components: {ProcessingGif},
  props: {
    item: Object
  },
  data: function() {
    return {
      processing: true,
      memberId: null,
      username: null,
      password: null
    }
  },
  methods: {
    close: function() {
      this.$bvModal.hide('memberinfo-' + this.item.id.toString())
    }
  },
  created() {
    if (!this.item.can_cancel_subscription || (!this.item.club_id && !this.item.order.club_id)) {
      this.processing = false // no member info to show, so nothing to do
    } else {
      axios.get('/order_items/' + this.item.id.toString() + '/membership/')
        .then(result => {
          console.log(result)
          this.memberId = result.data.member_id
          this.username = result.data.member_username
          this.password = result.data.member_password
          this.processing = false
        }, error => {
          console.error(error)
          this.processing = false
        })
    }
  }
}
</script>

<style scoped>

</style>
